import { IconSync } from '@montel/montelpro-shared-components-v2';
import { TMenuItem } from 'components/common/Menu';

const menuConfig: TMenuItem[] = [
	{
		type: 'Clickable',
		text: 'HubSpot sync',
		link: '/developer/hubspot',
		icon: <IconSync />,
	},
	{
		type: 'Clickable',
		text: 'HubSpot single sync',
		link: '/developer/connect-hubspot',
		icon: <IconSync />,
	},
	{
		type: 'Clickable',
		text: 'FusionAuth sync',
		link: '/developer/fusionauth',
		icon: <IconSync />,
	},
	{
		type: 'Clickable',
		text: 'Assign seat',
		link: '/developer/assign-seat',
		icon: <IconSync />,
	},
	{
		type: 'Clickable',
		text: 'Permission cache tools',
		link: '/developer/permissions-cache',
		icon: <IconSync />,
	},
	{
		type: 'Clickable',
		text: 'Younium import',
		link: '/developer/younium-import',
		icon: <IconSync />,
	},
	{
		type: 'Clickable',
		text: 'Sync admin accounts',
		link: '/developer/sync-admin-accounts',
		icon: <IconSync />,
	},
];

export default menuConfig;
